// @flow
import { type Node, forwardRef } from 'react';
import { animated, useSpring } from 'react-spring/web.cjs';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';

type PropsType = {
  children: Node,
  className?: string,
  isLoading: boolean
};

const loadingShimmer = keyframes`
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
`;

const TransitionSpan = animated(styled.span`
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${loadingShimmer};
  animation-timing-function: linear;
  background: transparent;
  background-size: 1000px 640px;
  display: inline-block;
`);

const LoadingSpan = forwardRef<PropsType, HTMLSpanElement>(
  ({ isLoading, className, children }: PropsType, ref) => {
    const loadingTransition = useSpring({
      visibility: isLoading ? 0 : 1
    });

    return (
      <TransitionSpan
        className={className}
        ref={ref}
        style={{
          backgroundImage: loadingTransition.visibility.interpolate((value) => {
            const v = 1 - value;
            return `linear-gradient(to right, rgba(0,0,0,${
              v * 0.05
            }) 14%, rgba(0,0,0,${v * 0.18}) 46%, rgba(0,0,0,${v * 0.05}) 64%)`;
          })
        }}
      >
        <animated.span style={{ opacity: loadingTransition.visibility }}>
          {children || <span>&nbsp;</span>}
        </animated.span>
      </TransitionSpan>
    );
  }
);

export default LoadingSpan;
